const React = require('react')
const { component } = require('../odo/odojs')
const inject = require('injectinto')
const ql = require('../odo/odoql').use('store')
const route = require('odo-route')
const markdown = require('../shared/markdown')
const normalpage = require('./normalpage')

route('/terms-of-use', p => {
  return { page: 'termsofuse' }
})

inject.bind(
  'page:termsofuse',
  component({
    query: params => ({
      content: ql.store(['terms_of_use'], 'content')
    }),
    render: (state, params, hub) => {
      document.title = 'Asset Altitude'
      return normalpage(markdown(state.content.terms_of_use))
    }
  })
)

route('/privacy-policy', p => {
  return { page: 'privacypolicy' }
})

inject.bind(
  'page:privacypolicy',
  component({
    query: params => ({
      content: ql.store(['privacy_policy'], 'content')
    }),
    render: (state, params, hub) => {
      document.title = 'Asset Altitude'
      return normalpage(markdown(state.content.privacy_policy))
    }
  })
)
